import { useEffect } from 'react';
import useSyncedRef from 'src/hooks/utils/useSyncedRef';

interface Params {
	callback: () => void;
	delayMs: number;
	runOnCallbackChange?: boolean;
}

/**
 * Invokes the callback upon mount, then executes it at a specified interval.
 */
export function useImmediateInterval({
	callback,
	delayMs,
	runOnCallbackChange,
}: Params) {
	const callbackRef = useSyncedRef(callback);

	// Execute callback on change if specified.
	useEffect(() => {
		runOnCallbackChange && callbackRef.current();
	}, [callback, runOnCallbackChange]);

	// Set up the interval.
	useEffect(() => {
		function tick() {
			callbackRef.current();
		}

		tick();

		if (delayMs) {
			const id = setInterval(tick, delayMs);
			return () => {
				clearInterval(id);
			};
		}
	}, [delayMs]);
}
